import React from 'react';
import { Container, Card, Button } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../auth/AuthContext';

const PageNotFound = () => {
  const navigate = useNavigate();
  const { userProfile } = useAuth();

  const handleGoHome = () => {
    // Navigate to appropriate dashboard based on role
    if (!userProfile) {
      navigate('/login');
      return;
    }

    switch (userProfile.role) {
      case 'admin':
        navigate('/admin');
        break;
      case 'facilitator':
        navigate('/facilitator');
        break;
      case 'assessor':
        navigate('/assessor');
        break;
      case 'qa':
        navigate('/qa');
        break;
      case 'external':
        navigate('/external');
        break;
      case 'learner':
        navigate('/dashboard');
        break;
      default:
        navigate('/login');
    }
  };

  return (
    <Container className="mt-5">
      <Card className="text-center shadow-sm">
        <Card.Body className="py-5">
          <div className="mb-4">
            <h1 className="display-1 text-primary" style={{ fontSize: '8rem', fontWeight: 'bold' }}>
              404
            </h1>
          </div>
          <h2 className="mb-3">Page Not Found</h2>
          <p className="text-muted mb-4">
            Sorry, the page you are looking for does not exist or has been moved.
          </p>
          <div className="d-flex gap-3 justify-content-center">
            <Button variant="primary" size="lg" onClick={handleGoHome}>
              Go to Dashboard
            </Button>
            <Button variant="outline-secondary" size="lg" onClick={() => navigate(-1)}>
              Go Back
            </Button>
          </div>
          <div className="mt-5 text-muted">
            <small>
              If you believe this is an error, please contact your administrator.
            </small>
          </div>
        </Card.Body>
      </Card>
    </Container>
  );
};

export default PageNotFound;
